<template>
  <div class="header-top">
    <div class="site-header site-wrapper">
      <div class="site-header__brand">
        <a href="javascript:;" class="logo"><img src="../../../public/page_logo.png" alt="" /></a>
      </div>
      <div class="site-header__nav">
        <ul class="clearfix">
          <li>
            <a href="javascript:;" @click="$router.push({ name: 'home' })">首页</a>
          </li>
          <li>
            <a href="javascript:;" @click="$router.push({ name: 'introduction' })">公司概况</a>
          </li>
          <li>
            <a href="javascript:;" @click="$router.push({ name: 'centerNews' })">新闻公告</a>
          </li>
          <li>
            <a href="javascript:;" @click="$router.push({ name: 'credential' })">资质荣誉</a>
          </li>
          <li>
            <a href="javascript:;" @click="$router.push({ name: 'ingredient' })">仪器设备</a>
          </li>
          <li>
            <a href="javascript:;" @click="$router.push({ name: 'demand' })">技术服务</a>
          </li>
          <li>
            <a href="javascript:;" @click="$router.push({ name: 'contactUs' })">联系我们</a>
          </li>
        </ul>
      </div>
      <div class="site-header__lors">
        <span @click="$router.push({ name: 'login' })">登录</span>
        <el-divider direction="vertical"></el-divider>
        <span @click="$router.push({ name: 'register' })">注册</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    tipLogin() {
      this.$message.error("请登录！");
    },
  },
};
</script>

<style lang="scss" scoped>
/**header 高 */
$--header-height: 80px;
.header-top {
  background: #fff;
  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.04);
  .site-header {
    display: flex;
    height: $--header-height;
    line-height: $--header-height;
    &__brand {
      padding-left: 0px;
      .logo {
        img {
          height: 40px;
        }
      }
    }
    &__nav {
      flex: 1;
      text-align: center;
      ul > li {
        display: inline-block;
        &.active a {
          background: #1460ae;
          color: #fff;
        }
        :hover {
          background: #1460ae;
          color: #fff;
        }
        a {
          display: block;
          font-size: 16px;
          padding: 0 24px;
          text-decoration: none;
        }
      }
    }
    &__lors {
      span {
        cursor: pointer;
      }
    }
  }
}
</style>
